/* eslint-disable semantic/ask -- o checkout (curseduca-front) não tem mecanismo de tradução: todo texto da tela é pt-BR escrito no componente, como no resto do app. */
/**
 * O que o comprador vê quando a página do checkout quebra ao renderizar (Sentry.ErrorBoundary em
 * src/index.tsx). Sem dependência de tema, contexto ou API: é o que sobra quando tudo mais falhou.
 */
export const CheckoutCrashFallback = () => (
	<div
		role="alert"
		style={{
			minHeight: '100vh',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: 16,
			fontFamily: 'system-ui, sans-serif',
			background: '#f6f6f6',
			color: '#2b2b2b'
		}}
	>
		<div style={{ maxWidth: 420, textAlign: 'center' }}>
			<h1 style={{ fontSize: 20, marginBottom: 8 }}>
				Não foi possível carregar esta página
			</h1>
			<p style={{ fontSize: 15, marginBottom: 20 }}>
				Recarregue a página para tentar de novo. Se você já tinha
				finalizado a compra, confira seu e-mail antes de pagar outra
				vez.
			</p>
			<button
				type="button"
				onClick={() => window.location.reload()}
				style={{
					padding: '10px 20px',
					fontSize: 15,
					borderRadius: 6,
					border: 'none',
					background: '#234131',
					color: '#fff',
					cursor: 'pointer'
				}}
			>
				Recarregar
			</button>
		</div>
	</div>
);
